import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from './pmi-select';
import { PmiFormControl } from './pmi-select/pmi-form-control';

export enum ID_GENDERS {
  MASCHIO = 'M',
  FEMMINA = 'F',
  SCONOSCIUTO = 'N',
}

const genders = Object.freeze([
  {
    id: ID_GENDERS.MASCHIO,
    value: 'Maschio',
  },
  {
    id: ID_GENDERS.FEMMINA,
    value: 'Femmina',
  },
  {
    id: ID_GENDERS.SCONOSCIUTO,
    value: 'Sconosciuto',
  },
]);

interface ListGenderProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  helperText?: string;
  isSmallSize?: boolean;
  withoutUnknown?: boolean;
}

const ListGenderComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  helperText,
  isSmallSize = false,
  withoutUnknown = false,
}: ListGenderProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="gender-label">
        {required ? 'Sesso *' : 'Sesso'}
      </InputLabel>
      <PmiSelect
        labelId="gender-label"
        id="gender"
        name="gender"
        value={value}
        label={required ? 'Sesso *' : 'Sesso'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {genders
          .filter((item) => !(withoutUnknown && item.id === ID_GENDERS.SCONOSCIUTO))
          .map((gender: ItemVM) => (
            <MenuItem key={gender.id} value={gender.id}>
              {gender.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListGenderComponent.displayName = 'List Gender component';

const ListGender = memo(ListGenderComponent);

export default ListGender as typeof ListGenderComponent;
